module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0008#acknow",
      "id": "racknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0009#intro",
      "id": "rintro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0010#ch01",
      "id": "rch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Quality TV, Gender, and the Politics of Cultural Transgression")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0011#pt01",
      "id": "rpt01"
    }
  }, [_vm._v("Comedies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0012#ch02",
      "id": "rch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" The “Feminist Comedy of Distinction”: Genre and Gender in the Female-Centered Quality Sitcom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0013#ch03",
      "id": "rch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" Negotiating (Post)Feminism in Feminist Quality Comedy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0014#ch04",
      "id": "rch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" Body Politics and the Quality Comedy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0015#pt02",
      "id": "rpt02"
    }
  }, [_vm._v("Dramas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0016#ch05",
      "id": "rch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" Cultural Status and Genre in the Female-Centered Prestige Drama")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0017#ch06",
      "id": "rch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" Female-Centered Prestige Drama and (Post)Feminism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0018#conc",
      "id": "rconc"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0019#biblio",
      "id": "rbiblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0020#ch07",
      "id": "rch07"
    }
  }, [_vm._v("List of Television Programs and Films")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0021#index",
      "id": "rindex"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0022#aubio",
      "id": "raubio"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c963782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-havas-0007.vue
// module id = 72
// module chunks = 0